<div class="p-payment-method-cvs">
  <div class="p-payment-method-cvs__item">
    <span class="u-visually-hidden" [innerHTML]="'alt.convenienceStore' | staticMsg"></span>
    <h3
      class="p-payment-method-cvs__item-title p-payment-method-cvs__item-title--m"
      [innerHTML]="'alt.convenienceStore' | staticMsg"
    ></h3>
    <div class="p-payment-method-cvs__item-contents">
      <div class="p-payment-method-cvs__item-block">
        <ul class="p-payment-method-cvs__cvs">
          <li class="p-payment-method-cvs__cvs-item">
            <img src="assets/images/img_cvs_1.jpg" width="32" height="32" alt="{{ 'alt.seveneleven' | staticMsg }}" />
          </li>
          <li class="p-payment-method-cvs__cvs-item">
            <img
              src="assets/images/img_cvs_2.jpg"
              width="256"
              height="33"
              alt="{{ 'alt.lawson' | staticMsg }}{{ 'alt.ministop' | staticMsg }}{{ 'alt.familyMart' | staticMsg }}"
            />
          </li>
          <li class="p-payment-method-cvs__cvs-item">
            <img
              src="assets/images/img_cvs_3.jpg"
              width="256"
              height="33"
              alt="{{ 'alt.seicomart' | staticMsg }}{{ 'alt.dailyYamazaki' | staticMsg }}{{
                'alt.yamazakiDailyStore' | staticMsg
              }}"
            />
          </li>
        </ul>
      </div>
      <div class="p-payment-method-cvs__item-block">
        <p
          class="p-payment-method-cvs__item-text p-payment-method-cvs__item-text--fs16"
          [innerHTML]="'message.convenienceStore' | staticMsg"
        ></p>
      </div>
    </div>
  </div>
</div>
